import User from '@/api/user';

const user = {
  namespaced: true,

  state: {
    // 令牌
    token: null,

    // 用户信息
    info: null,
  },

  getters: {
    loggedIn(state) {
      return !!state.token;
    },

    infoIsReady(state) {
      return !!state.info;
    },
  },

  mutations: {
    setToken(state, value) {
      state.token = value;
    },

    setInfo(state, value) {
      state.info = value;
    },
  },

  actions: {
    // 获取用户信息
    async getInfo({ commit }) {
      const response = await User.info();
      commit('setInfo', response.data);
      return response.data;
    },

    // 退出登录
    async logout({ commit }) {
      // await User.logout();
      commit('setToken', null);
      commit('setInfo', null);
    },
  },
};

export default user;
